import MainContainer from '../../../components/ui_components/MainContainer';
import { useLoaderData, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import colors from '../../../styles/colors';

const Wrapper = styled.div`
    width: 80%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    margin: 0 auto;

    & h1, h2, h3, h4, h5, h6 {
        margin: 0;
        padding: 0;
        font-family: CameronSansMedium, CameronSansLight, Trebuchet MS, Arial, Helvetica, Verdana, Tahoma, sans-serif;
    }
`;

const ContainerInfoBelt = styled.div`
    width: 100%;
    height: 120px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: ${colors.bgColorBlack2};
    border-radius: 8px;
    padding: 10px;
    border: 2px solid ${colors.bgColorBordeaux};
    margin-bottom: 10px;

    & .belt-name {
        font-size: 20px;
        font-weight: 500;
        color: white;
    }

    & .belt-img {
        width: 100%;
        max-height: 80px;
        object-fit: contain;
        object-position: center;
    }
`;

const BoxChampions = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    row-gap: 5px;
`;

const SingleChampionRow = styled.div`
    height: 50px;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border: 2px solid black;
    background-color: ${colors.bgColorBordeaux};
    border-radius: 5px;
    padding: 0 10px;

    &:hover {
        cursor: pointer;
        background-color: ${colors.bgColorBordeaux};
    }
`;

const LeftSize = styled.div`
    width: 50px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    & img.wrestler-img {
        width: 40px;
        height: 40px;
        object-fit: cover;
        object-position: top;
        border: 1px solid white;
    }
`;

const RightSize = styled.div`
    width: calc(100% - 50px);
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    & .top-size,
    & .bottom-size {
        width: 100%;
        height: 15px;
        display: flex;
        align-items: center;
        justify-content: center;

        & h6 {
            font-size: 6px;
            font-weight: 500;
            color: white;
            text-align: center;
            margin: 0;
        }
    }

    & .center-size-info-row {
        width: 100%;
        height: calc(100% - 30px);
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        & .name-champion {
            font-size: 12px;
            font-weight: 500;
            color: white;
            text-align: center;
            margin: 0;
        }
    }
`;

const SingleBeltInfoMobile = () => {
    const beltData = (useLoaderData() as any)?.data;
    const navigate = useNavigate();

    const navigateToPpv = (ppvId: string, ppvName: string): void => {
        navigate(`/ppv/specific/i_${ppvId}_d_${ppvName}`);
    };

    return (
        <MainContainer className='single-belt-info-mobile-container' isMobile={true}>
            <Wrapper className='wrapper-single-belt-info-mobile'>

                <ContainerInfoBelt className='container-info-belt'>
                    <h1 className='belt-name'>{beltData.name}</h1>
                    <img className='belt-img' src={process.env.REACT_APP_STORAGE_URL + beltData.img_path} alt={beltData.name} />
                </ContainerInfoBelt>

                <BoxChampions className='box-champions'>
                    {beltData.wrestlers.map((wrestler, index) => (
                        <SingleChampionRow 
                         className='single-champion-row' 
                         key={index} 
                        //  onclick funziona solo se minuscolo(wrestler.ppv_name è diverso da fear, tap out o lite 
                         onClick={() => {
                            if (wrestler.ppv_name.toLowerCase() !== 'fear' && wrestler.ppv_name.toLowerCase() !== 'tap out' && wrestler.ppv_name.toLowerCase() !== 'lite') {
                                navigateToPpv(wrestler.ppv_id, wrestler.ppv_name);
                            }
                         }}
                        >
                            <LeftSize className='left-size'>
                                {/* se wrestler.avatar_path esiste faccio l'img, altrimenti il div cosi rimane vuoto */}
                                {wrestler.avatar_path ? (
                                    <img className='wrestler-img' src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path} alt={wrestler.name} />
                                ) : (
                                    <div className='wrestler-img' />
                                )}
                            </LeftSize>

                            <RightSize className='right-size'>
                                <div className='top-size'>
                                    <h6 className='text-name-ppv'>{wrestler.ppv_name}</h6>
                                </div>

                                <div className='center-size-info-row'>
                                    <h2 className='name-champion'>{wrestler.name ? wrestler.name : 'VACANTE'}</h2>
                                </div>

                                <div className='bottom-size'>
                                    <h6 className='text-date-ppv'>{wrestler.date_win}</h6>
                                </div>

                            </RightSize>
                        </SingleChampionRow>
                    ))}
                </BoxChampions>
            </Wrapper>
        </MainContainer>
    );
};

export default SingleBeltInfoMobile;